

exports.register = (module) ->
    module.service 'Core.Services.Loading', ['$rootScope', '$compile', exports.Loading]


class exports.Loading
    constructor: (@rootScope, @compile) ->
        return

    overMap: (msg = 'Loading...') =>
        return @_load @_template(msg), '#master_content', ['loader-over-map']


    overSidebar: (msg = 'Loading...') =>
        return @_load @_template(msg), '.map_sidebar:visible', ['loader-over-sidebar']


    overMapAndSidebar: (msg = 'Loading...') =>
        return @_load @_template(msg), '#map_container', ['loader-over-map', 'loader-over-sidebar']


    overAll: (msg = 'Loading...') =>
        return @_load @_template(msg), 'body', ['loader-over-all']


    overCustom: (selector, msg = 'Loading...', modifier = null, classes = ['loader-over-absolute']) =>
        if modifier
            return @_load @_template(msg, "preloader-container #{modifier}"), selector, classes

        return @_load @_template(msg), selector, classes


    hideAll: () =>
        angular.element('.loader-wrap').remove()


    _load: (template, wrapper, addclasses = []) =>
        elem = angular.element template

        addclasses = [addclasses] if not $.isArray(addclasses)
        for cls in addclasses
            elem.addClass cls

        elem = angular.element "<div class='bs2'>"
        .append elem
        compiled = @compile elem
        angular.element(wrapper).append elem
        compiled(@rootScope)

        return {
            hide: () -> elem.remove()
        }


    _template: (msg, container_class = 'preloader-container') =>
        return """
            <div class='loader-wrap'>
                <div class='#{container_class}'>
                    <div class='preloader-message'>
                        <div class='preloader-spinner' us-spinner='{radius:18, length: 18, width:4, color: "#FFFFFF"}'>
                        </div>
                        <div class='preloader-text'>#{msg}</div>
                    </div>
                </div>
            </div>
        """
